import React from 'react';
import { HeaderBar } from 'app/components/HeaderBar';
import { FramelessTitleBar } from './FramelessTitleBar';

export const TitleBar = () => (
  <FramelessTitleBar>
    <HeaderBar />
  </FramelessTitleBar>
);
